module.exports = __webpack_public_path__ + "static/media/CrowdStrike_Logo_dark_mode.53a6cbe5.png";